import { gql } from "@apollo/client";
import { TRANSACTION_INFO } from "../fragments";

export const GET_MEMBER_TRANSACTION_LIST = gql`
  query getMemberTransactionList($action: String!, $member: ID!) {
    getMemberTransactionList(action: $action, member: $member) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const GET_TRANSACTION_LIST = gql`
  query getTransactionList($action: String!) {
    getTransactionList(action: $action) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const GET_TRANSACTION_REQUEST = gql`
  query getTransactionRequests($action: String!) {
    getTransactionRequests(action: $action) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;

export const GET_TRANSACTION_RECORD = gql`
  query transactionRecord($action: String!, $member: ID!) {
    transactionRecord(action: $action, member: $member) {
      ...transactionInfo
    }
  }
  ${TRANSACTION_INFO}
`;
